import { Platform } from 'react-native';

type PrivacyFlag = 'sensitive' | 'private' | 'financial';
type WebDataSet = Record<string, string | number | boolean>;

/**
 * Adds web-only data attributes consumed by replay/privacy tooling.
 *
 * Keep this on leaf data elements only. Adding these flags to layout wrappers
 * like PageContainer, Card, ScrollView, or row containers can cause session
 * replay tools to block the whole subtree instead of only the sensitive value.
 */
export function webPrivacyProps(
  flags: PrivacyFlag | PrivacyFlag[],
  existingDataSet?: WebDataSet | null,
) {
  if (Platform.OS !== 'web') return {};

  const dataSet: WebDataSet = { ...(existingDataSet ?? {}) };
  for (const flag of Array.isArray(flags) ? flags : [flags]) {
    dataSet[flag] = 'true';
  }

  return { dataSet };
}
